module.exports = __webpack_public_path__ + "static/room--bed.79eb97f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/room--bed.png
// module id = 32
// module chunks = 8482045208941 35783957827783 105603797122985 114276838955818 126609682503911 164485488089077 252234152318474